<template>
    <v-card v-if="myData != null" flat>
        <v-card-text>
            <v-row v-if="myData.terminy.length == 0">
                <p>Aktívne termíny nie sú k dispozícii</p>
            </v-row>
            <v-row v-for="termin,index in myData.terminy" :key="index" @click="rozbalTermin(termin.id)" v-bind:id="'termin'+termin.id">
                <v-col cols=12>
                    <v-card variant="outlined">
                        <v-card-title>
                            <v-row style="margin:5px">
                                {{termin.termin}}
                                <v-spacer />
                                Hodnotené: {{termin.ohodnotene_praxe}}/{{termin.zoznam.length}}
                                <v-icon v-if="rozbalitTermin != termin.id">expand_more</v-icon>
                                <v-icon v-if="rozbalitTermin == termin.id" @mousedown="rozbalitTermin = -1">chevron_left</v-icon>
                            </v-row>
                            </v-card-title>
                        <v-card-text v-if="rozbalitTermin == termin.id">
                            <v-row v-if="termin.zoznam.length > 0">
                                <v-col cols=12>
                                <v-card elevation="0" style="background-color:#E8F5E9;margin-bottom:3px" v-for="prax,index2 in termin.zoznam" :key="index2" v-bind:id="prax.id">
                                    <v-card-text>
                                        <v-row v-if="rozbalitPrax != prax.id" style="margin:5px" align="center">
                                            <div>
                                                <h3> {{prax.meno}} - {{prax.firma}} ({{prax.mesto}})</h3>
                                                <p>{{prax.start_praxe}} - {{prax.koniec_praxe}}</p>
                                                <p><b>Činnosti</b>: {{prax.napln_praxe}}</p>
                                                <p>(hodnotené: {{prax.pocet_hodnoteni_ucitel}})</p>
                                            </div>
                                           <v-spacer></v-spacer>
                                                <v-progress-circular
                                                    :size="40"
                                                    :width="10"
                                                    :model-value="prax.pocet_mojich_hodnoteni/myData.pocet_kriterii*100"
                                                    :color="getProgressColor(prax.pocet_mojich_hodnoteni/myData.pocet_kriterii)"
                                                >
                                                {{prax.pocet_mojich_hodnoteni}}
                                                </v-progress-circular>
                                                &nbsp;
                                            <v-btn v-if="rozbalitPrax != prax.id" variant="outlined" @click="ohodnot(prax.id,termin.id)">
                                                Hodnotiť
                                            </v-btn>
                                        </v-row>
                                    </v-card-text>
                                    <v-card v-if="rozbalitPrax == prax.id && localFeedback.length == 0 && evalOtazky != null" style="background-color:#2E7D32;margin:5px">
                                        <v-card-text>
                                        <v-row style="color:white;background-color:#2E7D32;margin:10px" align="center">
                                           <h2> {{prax.meno}} - {{prax.firma}} </h2>
                                           <v-spacer></v-spacer>
                                           <v-icon @click="updateData(prax.id)">close</v-icon>
                                        </v-row>
                                        <v-row style="background-color:#E8F5E9;margin:10px">
                                            <p><b>činnosti</b>: {{prax.napln_praxe}}</p>
                                        </v-row>
                                        </v-card-text>
                                    <v-card-text>
                                        <v-row v-for="otazka,index3 in evalOtazky" :key="index3">
                                            
                                                <v-card :style="striedajBackground(index3)" style="width:100%" elevation="0">
                                                    <v-card-text>
                                                            {{index3+1}}. {{otazka.otazka}}
                                                    </v-card-text>
                                                    <v-card-text>
                                                        <v-row style="margin:5px">
                                                            <v-spacer />
                                                            <v-rating :color="striedajColor(index3)" length="5" v-model="evalOtazky[index3].otazka_hodnota"
                                                                    half-increments size="compact" style="scale:1.5" clearable
                                                                    @input="ulozHodnotenie('rating', index3, otazka.id, otazka.prax_id,'0')"/>
                                                            <v-spacer />
                                                        </v-row>
                                                        <v-row style="margin:5px">
                                                            <v-btn size="small" variant="outlined" @click="ulozHodnotenie('neposuditelne', index3, otazka.id, otazka.prax_id,'1')">Neposúditeľné</v-btn>
                                                            <v-spacer />
                                                            <v-btn v-if="editOtazka != otazka.id" size="small" variant="outlined" @click="editOtazka = otazka.id">komentár</v-btn>                                                            
                                                        </v-row>
                                                        <v-row v-if="editOtazka == otazka.id" style="margin:5px;margin-top:10px">
                                                            <v-textarea rows="5" label="Komentár k hodnoteniu" 
                                                                        v-model="evalOtazky[index3].otazka_text" @blur="ulozHodnotenie('komentar', index3, otazka.id, otazka.prax_id,'0')" >                                                                
                                                            </v-textarea>
                                                        </v-row>
                                                        <v-row v-if="editOtazka == otazka.id" style="margin:5px">
                                                            <v-btn size="small" variant="outlined" @click="ulozHodnotenie('komentar', index3, otazka.id, otazka.prax_id,'0'); editOtazka = -1">Ulož</v-btn>                                                                                                                        
                                                        </v-row>
                                                        <v-row v-if="editOtazka != otazka.id && otazka.otazka_text.length>0" style="margin:5px">
                                                            <v-col cols=12>
                                                                <v-card variant="outlined">
                                                                    <v-card-text>
                                                                        <v-row style="margin:5px">                                                                    
                                                                            <p>{{otazka.otazka_text}}</p>
                                                                            <v-spacer />
                                                                            <v-btn size="small" variant="outlined" @click="evalOtazky[index3].otazka_text =''; ">Vymaž komentar</v-btn>
                                                                        </v-row>
                                                                    </v-card-text>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>                                             
                                            
                                                </v-card>
                                            
                                        </v-row>

                                    </v-card-text>
                                    <v-card-text>
                                        <v-row style="color:white;background-color:#2E7D32;margin:10px" align="center">
                                           <v-spacer></v-spacer>
                                           <v-icon @click="updateData(prax.id)">close</v-icon>
                                        </v-row>
                                    </v-card-text>
                                    </v-card>
                                    <v-card-text style="background-color:red;color:white" v-if="rozbalitPrax == prax.id && localFeedback.length > 0">
                                        <v-row style="margin:5px">
                                            <b>{{localFeedback}}</b>
                                            <v-spacer />
                                            <v-icon class="btn-close" @click="rozbalitPrax=-1, localFeedback=''">close</v-icon>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                </v-col>
                            </v-row>
                            <v-row v-if="termin.zoznam.length == 0" >
                                <v-col cols=12>
                                    <v-card style="background-color:#E8F5E9">
                                        <v-card-text>
                                            <p>prázdny termín</p>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>   
                </v-col>
            </v-row>
            <v-row style="margin:20px">
                <v-spacer />
                <h2>Hodnotených prác: {{myData.hodnotene_celkom}}</h2>                
            </v-row>
        </v-card-text>
    </v-card>   
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myData : null,
            rozbalitPrax: -1,
            rozbalitTermin: -1,
            localFeedback: '',
            evalOtazky: null,
            editOtazka: -1,
            saving: false,
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getTermsThesesData()
        },
        getTermsThesesData() {            
            axios.get('/get-practice-evaluation-data', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        ohodnot(_praxid,_terminid) {
            this.localFeedback = ''
            const _data = {
                termin_id: _terminid,
                prax_id: _praxid
            }
            this.initData()
            this.rozbalitPrax = _praxid
            axios.post('/get-practices-for-evaluation', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                // console.log(res.data)
                if (res.data.message != 'OK') {
                    this.localFeedback = res.data.message
                } else {
                    this.evalOtazky = res.data.otazky
                    this.gototo(_praxid)
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        ulozHodnotenie(_type,_index,_otazka_id, _otazka_prax_id,_neposuditelne) {
            if (_type == 'neposuditelne')
                this.evalOtazky[_index].otazka_hodnota = -1
            if (_type == 'komentar') this.editOtazka = -1
            const _data = {
                rating_type: _type,
                otazka_id: _otazka_id,
                prax_id: _otazka_prax_id,
                otazka_hodnota: this.evalOtazky[_index].otazka_hodnota,
                otazka_text: this.evalOtazky[_index].otazka_text,
                neposuditelne: _neposuditelne
            }
            axios.post('/save-practice-evaluation', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                // console.log(res.data, _data)
                if (res.data.message != 'OK') {
                    this.localFeedback = res.data.message
                } 
                this.saving = false
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        striedajBackground(index3) {
           return index3 %2==0 ? 'background-color:#FFFFFF' : 'color:white;background-color:#2E7D32'
        },
        striedajColor(index3) {
           return index3 %2==0 ? '#2E7D32':'#FFFFFF'
        },
        updateData(_prax_id) {
            this.rozbalitPrax = -1
            this.initData()            
            this.gototo(_prax_id)
        },
        gototo(_id) {
            const myid = document.getElementById(_id);
            let position = myid.getBoundingClientRect()
            window.scrollTo(position.left, position.top + window.scrollY - 50);
        },
        getProgressColor(_value) {
            if (_value == 0) return "red"
            if (_value < 0.99) return "orange"
            return "green"
        },
        rozbalTermin(_termin_id) {
            this.rozbalitTermin = _termin_id
          //  this.gototo('termin'+_termin_id)
        }
    },

}

</script>
